import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import {
  createEventTable,
  patchEventTable,
  deleteEventTable,
} from '../event-manager-client';

export function useCreateEventTable(campaignId: string) {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { table_name: string; capacity?: number; sort_order?: number }) =>
      createEventTable(apiFetch, campaignId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'campaigns', campaignId, 'event-tables'] });
    },
  });
}

export function usePatchEventTable(campaignId: string) {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ tableId, fields }: { tableId: number; fields: Partial<{ table_name: string; capacity: number; sort_order: number }> }) =>
      patchEventTable(apiFetch, campaignId, tableId, fields),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'campaigns', campaignId, 'event-tables'] });
    },
  });
}

export function useDeleteEventTable(campaignId: string) {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tableId: number) => deleteEventTable(apiFetch, campaignId, tableId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'campaigns', campaignId, 'event-tables'] });
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'campaigns', campaignId, 'event-members'] });
    },
  });
}
